import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Body } from 'app/components/Typography';
import { H3 } from 'app/components/Typography';
import { Box } from 'app/components/basic/Wrappers/Box';
import { Button } from 'app/components/BasicButtons/Button';
import { IconButton } from 'app/components/BasicButtons/IconButton';
import { Icon } from 'app/components/BasicIcons/FontAwesome';
import clsx from 'clsx';
import { translations } from 'locales/translations';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { SelectFile } from './SelectFile';
import { TypePicker } from './TypePicker';
import { Check } from 'app/components/BasicInputs/Check';
import { ImprotData } from '../Data';
import { ScreensId } from 'enums/ConfigurableTypes';
import { AutomaticAssetImportNamingPicker } from './AutomaticAssetImportNamingPicker';
import { useSelector } from 'react-redux';
import {
  selectAssetFieldSettings,
  selectglobalSettings,
} from 'app/slice/selectors';
import { AllowedSettings } from 'utils/globalSettings';
import { AutomaticAssetNamings } from 'enums/enums';
import { SelectImageFiles } from './SelectImageFiles';
import { ImportAdditionalData } from '../Actions/Types';
import { AssetAttributes } from 'enums/AssetAttributes';

export const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      height: '100%',
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0px',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(3),
      top: theme.spacing(3),
      color: theme.palette.grey[500],
    },
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    boxcontainer: {
      display: 'flex',
      width: '100%',
      height: '100%',
    },
    selectFileBox: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '24px',
    },
    selectImageBox: {
      display: 'flex',
      flexDirection: 'column',
    },
    infoBox: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '24px',
      padding: '10PX',
      backgroundColor: '#f0f9ff',
    },
  }),
);

export interface PopupImportExportStep1Props {
  title: string;
  filetype: Entity<string> | null;
  nextName: string;
  cancelName: string;
  ImportTenplateHandler: () => void;
  handleFileTypeChange: (value: Entity<string> | null) => void;
  next: () => void;
  cancel: () => void;
}
export function PopupImportExportStep1(props: PopupImportExportStep1Props) {
  const [filetype, setFiletype] = React.useState<Entity<string> | null>(
    props.filetype,
  );
  const { t } = useTranslation();
  const [fileIsSelected, setFileIsSelected] = React.useState<boolean>(false);
  const [importAssetImageFiles, setImportAssetImageFiles] = React.useState<
    boolean
  >(ImprotData.ImportAssetImageFiles);
  const classes = useStyles();
  const handleImportAssetImageFiles = React.useCallback((f: boolean) => {
    setImportAssetImageFiles(f);
  }, []);
  const handleFileTypeChange = React.useCallback(
    (value: Entity<string> | null) => {
      setFiletype(value);
      props.handleFileTypeChange(value);
    },
    [props],
  );
  const selectFileHandler = React.useCallback((value: boolean) => {
    setFileIsSelected(value);
  }, []);
  return (
    <>
      <Box className={clsx(classes.root)}>
        <Box style={{ height: '85%' }}>
          <Box className={classes.titleContainer}>
            <IconButton
              variant="ghost"
              aria-label="close"
              className={classes.closeButton}
              onClick={props.cancel}
              size="small"
            >
              <Icon icon="times" />
            </IconButton>
            <H3>{props.title}</H3>
          </Box>
          <Box className={clsx(classes.boxcontainer)}>
            <Box style={{ width: '50%' }}>
              {ImprotData.ScreenId === ScreensId.MyAssets &&
                ImprotData.ImportAdditionalData ===
                  ImportAdditionalData.none && (
                  <AssetProperties
                    ImportAssetImageFiles={handleImportAssetImageFiles}
                  />
                )}
              {importAssetImageFiles === false && (
                <>
                  <SelectFileBox
                    fileType={filetype}
                    handleFileTypeChange={handleFileTypeChange}
                    selectFileHandler={selectFileHandler}
                  />
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '384px',
                    }}
                  >
                    {t(translations.BulkImportTitle)}
                  </Box>
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '384px',
                    }}
                  >
                    <Button
                      startIcon={<Icon icon="download" />}
                      variant="white"
                      onClick={() => {
                        props.ImportTenplateHandler();
                      }}
                    >
                      {t(translations.GetTheTemplate)}
                    </Button>
                  </Box>
                </>
              )}
            </Box>
            <Box style={{ width: '50%' }}>
              <InfoBox ImportTenplateHandler={props.ImportTenplateHandler} />
            </Box>
          </Box>
        </Box>
        {importAssetImageFiles === false && (
          <Box style={{ height: '15%' }} className={clsx(classes.container)}>
            <Button onClick={props.next} disabled={!fileIsSelected}>
              {props.nextName}
            </Button>
            <Button
              variant="white"
              onClick={props.cancel}
              style={{ marginLeft: '10px' }}
            >
              {props.cancelName}
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
}

interface AssetPropertiesProps {
  ImportAssetImageFiles: (f: boolean) => void;
}
function AssetProperties(props: AssetPropertiesProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const [importAssetImageFiles, setImportAssetImageFiles] = React.useState<
    boolean
  >(ImprotData.ImportAssetImageFiles);
  const [
    autoGenerateAssetNamesBasedOn,
    setAutoGenerateAssetNamesBasedOn,
  ] = React.useState<Entity<number> | null>(
    ImprotData.AutoGenerateAssetNamesBasedOn,
  );
  const [updateQRCode, setUpdateQRCode] = React.useState<boolean>(
    ImprotData.UpdateQRCode,
  );
  const classes = useStyles();
  //const appSettings = useSelector(selectAppSettings);
  const app = useSelector(selectAssetFieldSettings);

  const showInternalCode = React.useMemo(
    () => app[AssetAttributes.InternalCode]?.Enabled === true,
    [app],
  );

  const settings = useSelector(selectglobalSettings);

  const ImportAssetAutoNaming = settings.GetString(
    AllowedSettings.AutomaticAssetNamings,
  );

  const handleImageChange = React.useCallback(
    event => {
      const value = event.target.checked;
      ImprotData.ImportAssetImageFiles = value;
      setImportAssetImageFiles(value);
      props.ImportAssetImageFiles(value);
    },
    [props],
  );
  const handleAutoNameingChange = React.useCallback(
    (value: Entity<number> | null) => {
      ImprotData.AutoGenerateAssetNamesBasedOn = value;
      setAutoGenerateAssetNamesBasedOn(value);
    },
    [],
  );
  const handleUpdateQRCodeChange = React.useCallback(event => {
    const value = event.target.checked;
    ImprotData.UpdateQRCode = value;
    setUpdateQRCode(value);
  }, []);
  return (
    <>
      <Box style={{ width: '384px', marginTop: '10px' }}>
        <Box>
          <Check
            name={'ImportAssetImageFiles'}
            id={'1'}
            checked={importAssetImageFiles}
            onChange={handleImageChange}
          />
          <Body bold={true}>{t(translations.ImportAssetImageFiles)}</Body>
        </Box>
        {(ImportAssetAutoNaming === '' ||
          parseInt(ImportAssetAutoNaming) ===
            (AutomaticAssetNamings.No as number)) && (
          <Box style={{ marginTop: '8px', marginBottom: '8px' }}>
            <AutomaticAssetImportNamingPicker
              name="AutomaticAssetImportNaming"
              fullWidth
              placeholder={t(translations.ImportAssetAutoNaming)}
              label={t(translations.ImportAssetAutoNaming)}
              disabled={false}
              value={autoGenerateAssetNamesBasedOn}
              info={t(translations.ImportAssetAutoNaming_info)}
              onChange={handleAutoNameingChange}
            />
          </Box>
        )}
        {showInternalCode && (
          <Box className={clsx(classes.container)}>
            <Check
              name={'UpdateQRCode'}
              id={'2'}
              checked={updateQRCode}
              onChange={handleUpdateQRCodeChange}
            />
            <Body bold={true}>{t(translations.ImportAssetsUpdateQRcodes)}</Body>
            <IconButton
              title={t(translations.ImportAssetsUpdateQRcodesInfo)}
              variant="ghost"
              shape="square"
              size="small"
            >
              <Icon icon="info-circle" color="primary" />
            </IconButton>
          </Box>
        )}
        {importAssetImageFiles && (
          <SelectImageFilesBox selectFileHandler={() => {}} />
        )}
      </Box>
    </>
  );
}
interface SelectFileBoxProps {
  handleFileTypeChange: (value: Entity<string> | null) => void;
  selectFileHandler: (value: boolean) => void;
  fileType: Entity<string> | null;
}
function SelectFileBox(props: SelectFileBoxProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const [filetype, setFiletype] = React.useState<Entity<string> | null>(
    props.fileType,
  );
  const classes = useStyles();
  const downloadMime = undefined;
  const downloadFileExtension =
    downloadMime === undefined ? undefined : filetype;
  const downloadFileName =
    downloadFileExtension === undefined ? undefined : undefined;
  const handleChange = React.useCallback(
    (value: Entity<string> | null) => {
      setFiletype(value);
      props.handleFileTypeChange(value);
    },
    [props],
  );
  const fh = React.useMemo((): React.ReactNode => {
    let s = t(translations.MaxFileSize);
    s = s.replace('{0}', '100');
    return (
      <>
        <Body bold={true}>{t(translations.DragTheFilesOrBrowse)}</Body>
        <div style={{ textAlign: 'center' }}> {s} </div>
      </>
    );
  }, [t]);
  return (
    <Box
      className={clsx(classes.selectFileBox)}
      style={{ width: '384px', height: '256' }}
    >
      <TypePicker
        name="ImportFileType"
        fullWidth
        placeholder={t(translations.ImportFileType)}
        label={t(translations.ImportFileType)}
        disabled={false}
        value={filetype}
        onChange={handleChange}
      />
      <Box style={{ marginTop: '10px' }}>
        <SelectFile
          name="Xml"
          multiline={true}
          fullWidth
          placeholder={t(translations.Template)}
          label={t(translations.Template)}
          disabled={false}
          accept={filetype !== null ? filetype.Id : ''}
          downloadFileName={downloadFileName}
          filesPlaceholder={fh}
          selectFileHandler={props.selectFileHandler}
        />
      </Box>
    </Box>
  );
}
interface SelectImageFilesBoxProps {
  selectFileHandler: (value: boolean) => void;
}
function SelectImageFilesBox(props: SelectImageFilesBoxProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const fh = React.useMemo((): React.ReactNode => {
    let s = t(translations.MaxFileSize);
    s = s.replace('{0}', '100');
    return (
      <>
        <Body bold={true}>{t(translations.DragTheImagesOrBrowse)}</Body>
        <br />
        <div style={{ color: 'black' }}>
          {t(translations.AssetImgSupportedTypes)}
        </div>
        <div style={{ textAlign: 'center' }}> {s} </div>
      </>
    );
  }, [t]);
  const accept = {
    'application/png': ['.png'],
    'application/jpg': ['.jpg'],
    'application/gif': ['.gif'],
    'application/bmp': ['.bmp'],
    'application/jpe': ['.jpe'],
    'application/jpeg': ['.jpeg'],
    'application/ico': ['.ico'],
  };
  return (
    <Box
      className={clsx(classes.selectImageBox)}
      style={{ width: '384px', height: '256' }}
    >
      <Box>
        <SelectImageFiles
          name="Images"
          multiline={true}
          fullWidth
          placeholder={t(translations.Template)}
          label={t(translations.Template)}
          disabled={false}
          accept={accept}
          filesPlaceholder={fh}
        />
      </Box>
    </Box>
  );
}

interface InfoBoxProps {
  ImportTenplateHandler: () => void;
}
function InfoBox(props: InfoBoxProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const BulkCreateNewRecords: string[] = React.useMemo(() => {
    return t(translations.Bulk_CNR1).split('{0}');
  }, [t]);
  return (
    <Box className={clsx(classes.infoBox)} style={{ width: '488px' }}>
      <Box style={{ margin: '10px' }}>
        <Body bold={true}>
          {t(translations.ExcelImportSpecificRequirements)}
        </Body>
        <ul>
          <li>{t(translations.Excel_ISR1)}</li>
          <li>{t(translations.Excel_ISR2)}</li>
        </ul>
      </Box>
      <Box style={{ margin: '10px' }}>
        <Body bold={true}>{t(translations.CSVImportSpecificRequirements)}</Body>
        <ul>
          <li>{t(translations.CSV_ISR1)}</li>
        </ul>
      </Box>
      <Box style={{ margin: '10px' }}>
        <Body bold={true}>{t(translations.BulkCreateNewRecords)}</Body>
        <ul>
          <li>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {BulkCreateNewRecords[0]}
              <Button
                variant="text"
                onClick={() => {
                  props.ImportTenplateHandler();
                }}
              >
                {t(translations.Buli_CNR2)}
              </Button>
              {BulkCreateNewRecords[1]}
            </div>
          </li>
        </ul>
      </Box>
      <Box style={{ margin: '10px' }}>
        <Body bold={true}>{t(translations.UpdateExistingRecords)}</Body>
        <ul>
          <li>{t(translations.Update_ER1)}</li>
          <li>{t(translations.Update_ER2)}</li>
          <li>{t(translations.Update_ER3)}</li>
        </ul>
      </Box>
    </Box>
  );
}
